module.exports = {"410471001":"皇台街道","410471100":"遵化店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410471.json
// module id = 1562
// module chunks = 0